<template>
    <a v-bind="$attrs" :href="linkURL" :title="title" @click.prevent="onClick">
        <slot />
    </a>
</template>

<other>

<router-link v-bind="$props" v-slot="{ isActive, href, navigate }" @click.prevent="onClick">
        &ast; <slot />
    </router-link>

</other>

<script>
import { RouterLink } from 'vue-router';
import { mapActions } from 'vuex';

export default {
  name: 'StaticSearchLink',
  props: {
    ...RouterLink.props,    
    // to: {
    //   type: String,
    // },
    title: {
      type: String,
    },
    shouldEmit: {
        type: Boolean,
        default: false,
    },
  },
  methods: {
    ...mapActions('search', ['getStaticParameters', 'doSearch']),
    ...mapActions('industry', ['getIndustrySkills']),
    async onClick() {
        if (this.shouldEmit === true) {
            this.$emit('clickCallback', this.to);
        } else {
            // link_to is in globalMixin.js
            this.link_to(this.to);
        }
    },
  },
  computed: {
    linkURL() {
        // unpack_url is in globalMixin.js
        return this.unpack_url(this.to);
    },
  }
};
</script>
